// @flow

import React from 'react';
import { Glyphicon, Button, FormGroup, ControlLabel, Col, ListGroupItem } from 'react-bootstrap';
import type { FieldProps } from 'redux-form';
//import { postBasketData } from '../actions/basket';

let HOC = (Input: React.Component<void>) => {
  type Props = {
    handleEditState: Function,
    componentProps: Object
  } & FieldProps;

  return class extends React.Component<Props & FieldProps> {
    componentWillUpdate(nextProps: Object) {
      if (!nextProps.meta.asyncValidating && nextProps.meta.error === undefined) {
        if (nextProps.componentProps.type === 'time') {
          return;
          //setTimeout(() => {
          //return nextProps.meta.visited && !nextProps.meta.active ? this.onClickHandler() : undefined;
          //}, 200);
        }
        return !nextProps.meta.active ? this.onClickHandler() : undefined; //nextProps.meta.visited &&
      }
    }

    onClickHandler = () => {
      this.props.handleEditState(this.props.input.name, !this.props.meta.error);
    };

    render() {
      const { componentProps, input, meta: { error, visited } } = this.props;
      // console.log('input', input.value);
      return (
        <ListGroupItem>
          <FormGroup controlId={input.name} validationState={error ? 'error' : 'success'}>
            <Col componentClass={ControlLabel} xs={4}>
              <div style={{ width: '120%' }}>{componentProps.label}</div>
            </Col>
            <Col xs={6}>
              <Input {...this.props} className="text-left" style={{ width: '100%' }} />
              <span className="help-block">{(visited && error) || (!input.value && error)}</span>
            </Col>
            <Col xs={2}>
              <div className="text-center">
                <Button bsStyle="link" className="" onClick={this.onClickHandler}>
                  {/* TODO : may have to include onClick={this.onClickHandler} */}
                  <Glyphicon style={{ color: 'green' }} glyph="ok" />
                </Button>
              </div>
            </Col>
          </FormGroup>
        </ListGroupItem>
      );
    }
  };
};

export default HOC;



// WEBPACK FOOTER //
// ./src/components/GeneralInputField/index.js